import { Feedback, FeedbackResource } from './Feedback'

export const transformToFeedback = (resource: FeedbackResource): Feedback => ({
    rating: resource.attributes.rating,
    remark: resource.attributes.remark || undefined,
})
